import {
    FETCH_TASKTYPE_BEGIN,
    FETCH_TASKTYPE_SUCCESS,
    FETCH_TASKTYPE_FAILURE,
    FETCH_TASKS_BEGIN,
    FETCH_TASKS_SUCCESS,
    FETCH_TASKS_FAILURE,
    FETCH_TASKASSIGNEE_BEGIN,
    FETCH_TASKASSIGNEE_SUCCESS,
    FETCH_TASKASSIGNEE_FAILURE,
    FETCH_TASKDETAILS_BEGIN,
    FETCH_TASKDETAILS_SUCCESS,
    FETCH_TASKDETAILS_FAILURE,
    FETCH_TASKDOCUMENTS_BEGIN,
    FETCH_TASKDOCUMENTS_SUCCESS,
    FETCH_TASKDOCUMENTS_FAILURE,
    FETCH_TASKSETTINGVIEW_BEGIN,
    FETCH_TASKSETTINGVIEW_SUCCESS,
    FETCH_TASKSETTINGVIEW_FAILURE,
    FETCH_TASKVIEW_BEGIN,
    FETCH_TASKVIEW_SUCCESS,
    FETCH_TASKVIEW_FAILURE,
    FETCH_TASKVIEWCOLUMN_BEGIN,
    FETCH_TASKVIEWCOLUMN_SUCCESS,
    FETCH_TASKVIEWCOLUMN_FAILURE,
    FETCH_TASKVIEWCOLUMNBYVIEWID_BEGIN,
    FETCH_TASKVIEWCOLUMNBYVIEWID_SUCCESS,
    FETCH_TASKVIEWCOLUMNBYVIEWID_FAILURE,
  } from '../constants/tasks';



const initialState={
    tasks:[],
    taskType:[],
    taskDocuments:[],
    taskDetails:[],
    taskAssignee: [],
    TaskViewSettings: [],
    ActivityTaskView:[],
    taskviewColumns: [],
    AvailableTaskViewColumns:[],
    isAvailableColumnsLoading:false,
    isLoading:false,
    error:"",
    listLoading:false
}


export const getTasksReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    // task Type
    case FETCH_TASKTYPE_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_TASKTYPE_FAILURE:
        return {
            ...state,
            isLoading:false,
            taskType:null
        };
    case FETCH_TASKTYPE_SUCCESS:
        return {
            ...state,
            taskType:payload.taskType,
            isLoading:true,
        };
        // Tasks
        case FETCH_TASKS_BEGIN: {
            return {
              ...state,
              listLoading: true,
              tasks:[]
            };
          }
        case FETCH_TASKS_FAILURE:
            return {
                ...state,
                listLoading:false,
                tasks:[]
            };
        case FETCH_TASKS_SUCCESS:
            return {
                ...state,
                tasks:payload.tasks,
                listLoading:false,
            };
   // Task Assignee
            case FETCH_TASKASSIGNEE_BEGIN: {
                return {
                  ...state,
                  isLoading: true,
                  error: null,
                };
              }
            case FETCH_TASKASSIGNEE_FAILURE:
                return {
                    ...state,
                    isLoading:false,
                    tasks:null
                };
            case FETCH_TASKASSIGNEE_SUCCESS:
                return {
                    ...state,
                    taskAssignee:payload.taskAssignee,
                    isLoading:true,
                };
                // Task Details
            case FETCH_TASKDETAILS_BEGIN: {
                return {
                  ...state,
                  isLoading: true,
                  error: null,
                };
              }
            case FETCH_TASKDETAILS_FAILURE:
                return {
                    ...state,
                    isLoading:false,
                    taskDetails:null
                };
            case FETCH_TASKDETAILS_SUCCESS:
                return {
                    ...state,
                    taskDetails:payload.taskDetails,
                    isLoading:true,
                };
                   // Task Documents
            case FETCH_TASKDOCUMENTS_BEGIN: {
                return {
                    ...state,
                  isLoading: true,
                  error: null,
                };
              }
            case FETCH_TASKDOCUMENTS_FAILURE:
                return {
                    ...state,
                    isLoading:false,
                    taskDocuments:null
                };
            case FETCH_TASKDOCUMENTS_SUCCESS:
                return {
                    ...state,
                    taskDocuments:payload.taskDocuments,
                    isLoading:true,
         };

     // Task Task Setting view 
     case FETCH_TASKSETTINGVIEW_BEGIN: {
         return {
             ...state,
             isLoading: true,
             error: null,
         };
     }
     case FETCH_TASKSETTINGVIEW_FAILURE:
         return {
             ...state,
             isLoading: false,
             TaskViewSettings: null
         };
     case FETCH_TASKSETTINGVIEW_SUCCESS:
         return {
             ...state,
             TaskViewSettings: payload.TaskViewSettings,
             isLoading: true,
         };


     // Task Task  view 
     case FETCH_TASKVIEW_BEGIN: {
         return {
             ...state,
             isLoading: true,
             error: null,
         };
     }
     case FETCH_TASKVIEW_FAILURE:
         return {
             ...state,
             isLoading: false,
             ActivityTaskView: null
         };
     case FETCH_TASKVIEW_SUCCESS:
         return {
             ...state,
             ActivityTaskView: payload.ActivityTaskView,
             isLoading: true,
         };

         // Task view Column 
     case FETCH_TASKVIEWCOLUMN_BEGIN: {
        return {
            ...state,
            isLoading: true,
            error: null,
        };
    }
    case FETCH_TASKVIEWCOLUMN_FAILURE:
        return {
            ...state,
            isLoading: false,
            taskviewColumns: null
        };
    case FETCH_TASKVIEWCOLUMN_SUCCESS:
        return {
            ...state,
            taskviewColumns: payload.taskviewColumns,
            isLoading: true,
         };

     // Task view available Column 
     case FETCH_TASKVIEWCOLUMNBYVIEWID_BEGIN: {
         return {
             ...state,
             isAvailableColumnsLoading: true,
             error: null,
         };
     }
     case FETCH_TASKVIEWCOLUMNBYVIEWID_FAILURE:
         return {
             ...state,
             isAvailableColumnsLoading: false,
             AvailableTaskViewColumns: null
         };
     case FETCH_TASKVIEWCOLUMNBYVIEWID_SUCCESS:
         return {
             ...state,
             AvailableTaskViewColumns: payload.AvailableTaskViewColumns,
             isAvailableColumnsLoading: false,
         };
            default:
        return state;
 }
}


